import React from "react";
import "./user-snackbar.m.css";

export const UserSnackbar = ({ user, onLogout, onClose }) => {
  const email = user.email || (user.emails && user.emails[0]);
  const mobile = user.mobile || (user.phoneNumbers && user.phoneNumbers[0]);
  const identity = email || mobile || user.name || "User";

  return (
    <div styleName="snackbar">
      <div styleName="user-info">
        <span styleName="label">Logged in as:</span>
        <span styleName="value">{identity}</span>
      </div>
      <div styleName="actions">
        <button styleName="logout-btn" onClick={onLogout}>Logout</button>
        <button styleName="close-btn" onClick={onClose}>&times;</button>
      </div>
    </div>
  );
};
